<template>
  <v-layout class="list">
    <v-flex xs12 style="position:relative">
      <v-data-table
        v-model="selected"
        no-data-text="Keine Meldungen gefunden..."
        loading-text="Meldungen werden gesucht..."
        :headers="headers"
        :items="items"
        :page.sync="page"
        :itemsPerPage.sync="rowsPerPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
        :loading="isLoading"
        :footer-props="{
          'items-per-page-options': [20, 40, 60],
          'items-per-page-text': 'Meldungen pro Seite',
        }"
        :dense="denseRows"
        hide-default-header
        item-key="tick"
        class="elevation-1"
        :class="[denseRows ? 'pt-5' : 'pt-3']"
      >
        <template v-slot:header="{props}">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:item="props">
          <tr :class="[(showDetailId === props.item.src_id) ? 'active' : '', (props.item.webarc_hide === 1) ? 'hidden' : '']"
              @click="goToItem(props.item.src_id)">
            <td class="text-left">{{ dateString(props.item) }}</td>
            <td class="text-truncate headline-width">
              <v-icon v-if="props.item.webarc_hide === 1" small>mdi-lock</v-icon>
              {{ props.item.headline }}
            </td>
            <td class="text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.svc_name }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
/* tslint:disable:no-console */
import { mapState } from 'vuex';
export default {
  data() {
    return {
      descending: true,
      sortBy: 'tick',
      page: 1,
      rowsPerPage: 40,
      selected: [],
      search: '',
    };
  },
  mounted() {
    this.rowsPerPage = (window.innerWidth < 600) ? 20 : 40;

    this.$store.restored.then(() => {
      // when store is restored
      const payload = this.$store.state.app.userTokenPayload;
      const rightNow = Math.floor(new Date().getTime() / 1000);
      const restLife = payload.exp - rightNow;

      // token not expired
      if (!isNaN(restLife) && restLife > 0) {
        this.listInit();
      }
    });
  },
  computed: {
    items() {
      // filter by stored settings
      return this.$store.state.list.list;
    },
    showDetailId() {
      return this.$store.state.list.showDetailId;
    },
    isLoading: {
      get() {
        return this.$store.state.list.hasNewItems;
      },
      set(val) {
        this.$store.commit('newItems', val);
      },
    },
    headers() {
      const headers = this.$store.state.list.tableHeaders.filter((header, i) => {
        return !(this.$vuetify.breakpoint.xsOnly && i > 1);
      });
      return headers;
    },
    denseRows() {
      return this.$store.state.app.userSettings.denseRows;
    },
    ...mapState({
      userAuthenticated: (state) => state.app.userAuthenticated,
      username: (state) => state.app.username,
    }),
  },
  methods: {
    listInit() {
      if (this.$route.name === 'search') {
        const params = this.$route.params;
        const filters = this.$store.state.list.filters;

        // TODO: validation
        if (params.query && params.query !== filters.query) {
          this.$store.commit('updateSearchparameters', {key: 'query', val: params.query});
        }
        if (params.from && params.from !== 'null' && params.from !== filters.from) {
          this.$store.commit('updateSearchparameters', {key: 'from', val: params.from});
        }
        if (params.to && params.to !== 'null' && params.to !== filters.to) {
          this.$store.commit('updateSearchparameters', {key: 'to', val: params.to});
        }
        if (params.services && params.services !== 'null') {
          const services = params.services.split('~');
          if (filters.services.length !== services.length) {
            this.$store.commit('updateSearchparameters', {key: 'services', val: services});
          }
        }

        // trigger inital search once
        this.$store.dispatch('performSearch', 'listview');
      } else {
        this.fetchList();
      }
    },
    goToItem(id) {
      if (id !== this.$route.params.id) {
        this.$router.push({ name: 'detail', params: { id }});
      }
    },
    fetchList() {
      this.$store.dispatch('fetchList', 'listView');
    },
    dateString(item) {
      const date = item.at * 1000;
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      if (this.$vuetify.breakpoint.smAndDown) {
        options.month = 'numeric';
        options.year = '2-digit';
      }
      return new Date(date).toLocaleTimeString('de-DE', options);
    },
    changeSort(column) {
      if (this.sortBy === column) {
        this.descending = !this.descending;
      } else {
        this.sortBy = column;
        this.descending = false;
      }
    },
  },
  watch: {
    '$route'(to, from) {
      // fetch new list on navigating here
      if (to.name === 'home') {
        this.fetchList();
      }
    },
    '$store.state.list.list'(list) {
      // reset page to 1 on list change
      this.page = 1;
    },
    '$store.state.list.detail'(detail) {
      // react to locked items and update view data
      this.items.forEach((item) => {
        if (item.src_id === detail.src_id) {
          if (item.webarc_hide !== detail.webarc_hide) {
            item.webarc_hide = detail.webarc_hide;
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
table .v-progress-linear {
 height: 4px !important;
}
.icon-m-left i {
  margin-left: 10px;
}
tr.hidden {
  opacity: 0.5;
}
.floating-button {
    height: 64px;
    width: 100px;
    position: fixed;
    right: 40px;
    z-index: 99;
    bottom: 64px;
}
.v-datatable.v-table {
  .v-datatable__actions {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
.headline-width {
  max-width: 25vw;
}
.keywords-width {
  max-width: 15vw;
}
@media screen and (max-width: 899px) {
  .headline-width {
    max-width: 66vw;
  }
  .keywords-width {
    max-width: 34vw;
  }
}
.list table.v-table {
  margin-bottom: 60px;
}
.v-data-table td {
  cursor: pointer;
}
.v-input--selection-controls {
  margin-top: 0;
}
.v-application a {
  text-decoration: none;
}

@media screen and (max-width: 959px) {
  .v-data-table--dense {
    td {
      padding: 0 8px;
    }
  }
  .v-data-table, .v-data-table--dense {
    &.pt-5, &.pt-3 {
      padding-top: 0 !important;
    }
  }
}
</style>
